module.exports = __webpack_public_path__ + "img/Boxje_1.dc4b89e5.png";